
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[elementName]/p/[productSku]",
      function () {
        return require("private-next-pages/[elementName]/p/[productSku].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[elementName]/p/[productSku]"])
      });
    }
  